import dayjs from "dayjs";

const XLSX = require("xlsx");
const { saveAs } = require("file-saver");


export const buildFilterPayload = ({
  airports = [],
  airlines = [],
  statuses = [],
  years = [],
  months = [],
  quarters = [],
  startDate,
  endDate,
  view = "airport",
  limit = 0,
} = {}) => {
  const periodValues = [...months, ...quarters];
  const payload = {
    airports,
    airlines,
    statuses,
    years,
    months: periodValues,
    view,
  };

  if (limit) {
    payload.limit = limit;
  }

  if (startDate) {
    payload.start_date = dayjs(startDate).format("YYYY-MM-DD");
  }

  if (endDate) {
    payload.end_date = dayjs(endDate).format("YYYY-MM-DD");
  }

  return payload;
};


export const flattenAirlines = (airlines = {}) => {
  return Object.entries(airlines)
    .sort((a, b) => (b[1] || 0) - (a[1] || 0))
    .map(([name, value]) => `${name}: ${value}`)
    .join(" | ");
};


export const prepareRowsForExport = (rows = []) =>
  rows.map((row) => ({
    ...row,
    airlines: row.airlines ? flattenAirlines(row.airlines) : undefined,
  }));


export const exportRowsToExcel = (rows = [], filePrefix = "usage-dashboard", sheetName = "Data") => {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(prepareRowsForExport(rows));
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  const excelFile = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const fileName = `${filePrefix}_${dayjs().format("YYYYMMDD_HHmmss")}.xlsx`;
  saveAs(new Blob([excelFile]), fileName);
};


export const formatDate = (value, format = "DD MMM YYYY") => {
  if (!value) {
    return "-";
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(format) : String(value);
};


export const percent = (value) => `${Number(value || 0).toFixed(2)}%`;
